/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/books.scss';
import Tab from '../../component/Inc/Tab';

const InOutRequest = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '수능', value: 1},
    {title: '내신', value: 2}
  ];
  return (
    <main className="com_container com_books p_inout_request">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_5">
            교재 불출 요청하기
            <span className="bar" />
            <span className="point_txt">김교사103</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box box-half">
            <div className="default_tit bold">1. 교부받을 학생 선택</div>
            <div className="com_board_list__scroll check_box">
              <div className="input_row">
                <div className="check">
                  <input type="radio" name="rdo_1" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">판매</label>
                  <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">특별지급</label>
                  <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영업용</label>
                  <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">오발송</label>
                </div>
              </div>
              <div className="input_row">
                <section className="search search_top">
                  <input type="search" placeholder="학생명 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </section>
                <button className="com_btn gray s">조회</button>
              </div>
              <div className="input_row">
                <div className="check">
                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                  <label htmlFor="chk01">홍교사103 (교사)</label>
                </div>
              </div>
              <div className="input_row">
                <div className="check">
                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                  <label htmlFor="chk01">김학생103</label>
                  <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                  <label htmlFor="chk02">김학생103</label>
                  <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                  <label htmlFor="chk03">김학생103</label>
                  <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                  <label htmlFor="chk04">김학생103</label>
                </div>
              </div>
            </div>
            <div className="com_btn_wrap">
              <div className="com_btn black xs btn_plus_orange">선택한 학생 교재 교부</div>
            </div>
            <div className="default_tit bold">2. 학생별 교부 받을 교재 선택</div>
            <table className="com_board_list">
              <colgroup>
                <col width="15%" />
                <col width="35%" />
                <col width="50%" />
              </colgroup>
              <thead>
                <tr>
                  <th>취소</th>
                  <th>교부받는 사람</th>
                  <th>교부 받을 교재</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <button type="button" className="btn_del_file"></button>
                  </td>
                  <td>
                    <div className="check">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">홍교사103 (교사)</label>
                    </div>
                  </td>
                  <td className="td_left">
                    <div className="info">
                      <span className="txt">3214</span>
                      <span className="bar" />
                      <span className="txt">개념끝장 고등수학(2023년도 상 교재)</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button type="button" className="btn_del_file"></button>
                  </td>
                  <td>
                    <div className="check">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">홍교사103 (교사)</label>
                    </div>
                  </td>
                  <td className="td_left">
                    <div className="info">
                      <span className="txt">3214</span>
                      <span className="bar" />
                      <span className="txt">개념끝장 고등수학(2023년도 상 교재)</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button type="button" className="btn_del_file"></button>
                  </td>
                  <td>
                    <div className="check">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">홍교사103 (교사)</label>
                    </div>
                  </td>
                  <td className="td_left">
                    <div className="info">
                      <span className="txt">3214</span>
                      <span className="bar" />
                      <span className="txt">개념끝장 고등수학(2023년도 상 교재)</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button type="button" className="btn_del_file"></button>
                  </td>
                  <td>
                    <div className="check">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">홍교사103 (교사)</label>
                    </div>
                  </td>
                  <td className="td_left">
                    <div className="info">
                      <span className="txt">3214</span>
                      <span className="bar" />
                      <span className="txt">개념끝장 고등수학(2023년도 상 교재)</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />

              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="btn_wrapper">
              <button className="com_btn black xxs">국어</button>
              <button className="com_btn lightGray xxs">영어</button>
              <button className="com_btn lightGray xxs">수학</button>
              <button className="com_btn lightGray xxs">사탐</button>
              <button className="com_btn lightGray xxs">과탐</button>
              <button className="com_btn lightGray xxs">논술</button>
              <button className="com_btn lightGray xxs">면접</button>
              <button className="com_btn lightGray xxs">생디</button>
            </div>

            <div className="checkbox_wrap">
              <div className="check">
                <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                <label htmlFor="chk01">전체</label>
                <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                <label htmlFor="chk02">공식집</label>
                <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                <label htmlFor="chk03">개념끝장</label>
                <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                <label htmlFor="chk04">내신유형서</label>
                <input type="checkbox" name="chk" id="chk05" className="com_chk" />
                <label htmlFor="chk05">한권</label>
                <input type="checkbox" name="chk" id="chk06" className="com_chk" />
                <label htmlFor="chk06">이지웨이</label>
                <input type="checkbox" name="chk" id="chk07" className="com_chk" />
                <label htmlFor="chk07">기출리허설</label>
                <input type="checkbox" name="chk" id="chk08" className="com_chk" />
                <label htmlFor="chk08">모의고사</label>
                <input type="checkbox" name="chk" id="chk09" className="com_chk" />
                <label htmlFor="chk09">시크릿</label>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="15%" />
                <col width="35%" />
                <col width="50%" />
              </colgroup>
              <thead>
                <tr>
                  <th>선택</th>
                  <th>코드</th>
                  <th>교재명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>1234</td>
                  <td className="td_left">개념끝장 고등수학(상)</td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>1234</td>
                  <td className="td_left">개념끝장 고등수학(상)</td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>1234</td>
                  <td className="td_left">개념끝장 고등수학(상)</td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>1234</td>
                  <td className="td_left">개념끝장 고등수학(상)</td>
                </tr>
              </tbody>
            </table>
            <div className="com_btn_wrap center">
              <div className="com_btn black xs">선택한 교재 교부</div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">북카트 담기</button>
            </div>
          </section>
          <section className="box box-half">
            <div className="detail_tit dot">북카트 목록</div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="35%" />
                  <col width="65%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>작성일</th>
                    <th>작성내용 요약</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="td_date">2022, 08, 10</td>
                    <td>김학생103 외 (13명)</td>
                  </tr>
                  <tr className="highlight_row">
                    <td className="td_date">2022, 08, 10</td>
                    <td>김학생103 외 (13명)</td>
                  </tr>
                  <tr>
                    <td className="td_date">2022, 08, 10</td>
                    <td>김학생103 외 (13명)</td>
                  </tr>
                  <tr>
                    <td className="td_date">2022, 08, 10</td>
                    <td>김학생103 외 (13명)</td>
                  </tr>
                  <tr>
                    <td className="td_date">2022, 08, 10</td>
                    <td>김학생103 외 (13명)</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <button className="btn_edit"></button>
                <button className="btn_delete"></button>
              </div>
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="22%" />
                <col width="73%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>1. 교부자</th>
                  <td className="type_row">
                    <div className="td_info">
                      <p className="td_value">홍교사103 (대면수업학생)</p>

                      <div className="btn_wrap">
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>교부 교재</th>
                  <td className="type_row">
                    <div className="td_info">
                      <div className="info">
                        <span className="txt">3214</span>
                        <span className="bar" />
                        <span className="txt">개념끝장 고등수학(2023년도 상 교재)</span>
                      </div>

                      <div className="btn_wrap">
                        <button className="com_btn lightGray xs btn_count">4권</button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>배송 방법</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <div className="check">
                        <input type="radio" name="rdo2" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">직접수령</label>
                        <input type="radio" name="rdo2" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">착불수령</label>
                        <input type="radio" name="rdo2" id="rdo03" className="com_chk circle" />
                        <label htmlFor="rdo03">선불발송</label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>수령자</th>
                  <td>
                    <div className="com_input_wrap flex_row">
											<select name="" id="" className='select'>
												<option value="">수령자 이름</option>
											</select>
                      <input type="text" className="input" placeholder="수령자 전화번호" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>배송지</th>
                  <td>
                    <div className="com_input_wrap">
                      <div className="input_row flex_row">
                        <input type="text" className="input" placeholder="수령자 이름" />
                        <button className="com_btn gray xs">우편번호</button>
                      </div>
                      <hr className="com_divider td_divider" />
                      <div className="input_row">
                        <input type="text" className="input" placeholder="수령자 이름" />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="com_board_list type_row margin_btm">
              <colgroup>
                <col width="22%" />
                <col width="73%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>2. 교부자</th>
                  <td className="type_row">
                    <div className="td_info">
                      <p className="td_value">김학생320</p>

                      <div className="btn_wrap">
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>교부 교재</th>
                  <td className="type_row">
                    <div className="td_info">
                      <div className="info">
                        <span className="txt">3214</span>
                        <span className="bar" />
                        <span className="txt">개념끝장 고등수학(2023년도 상 교재)</span>
                      </div>

                      <div className="btn_wrap">
                        <button className="com_btn lightGray xs btn_count">4권</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <span className="txt com_red_txt center_align">* 교재 요청 후 15일 이내 수령하지 않으면 자동 삭제 됩니다.</span>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">교재 불출 요청</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default InOutRequest;
